<ca-modal-container [modalTitle]="modalTitle" (dismiss)="close()" data-uit="extend-trial-actions-dialog">
    <div class="pb-5">
        <p>{{ email }}</p>
        <p>{{ type }}</p>
        <p>{{ newEndDate }}</p>
    </div>
    <form [formGroup]="formGroup" novalidate>
        <div *ngIf="action === 'deny'" class="pb-5">
            <div class="d-flex flex-column-reverse">
                <textarea
                    id="message"
                    type="text"
                    class="form-control"
                    formControlName="message"
                    [placeholder]="'MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_ACTIONS_DIALOG.TEXTAREA.PLACEHOLDER' | translate"
                    required
                    data-uit="extend-trial-actions-message"
                    [ngClass]="formGroup.get('message')?.errors && formGroup.get('message')?.dirty ? 'has-error' : ''"
                ></textarea>
                <label class="" for="message"
                    >{{ 'MY_WORKSPACE.USER_PROFILE.SUBSCRIPTION.EXTEND_TRIAL_ACTIONS_DIALOG.TEXTAREA.LABEL' | translate }}<span class="ms-1 red">*</span></label
                >
            </div>
            <small *ngIf="formGroup.get('message')?.dirty && formGroup.get('message')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>

        <div class="modal-buttons">
            <button type="button" class="btn btn-secondary w-50" (click)="close()">
                {{ 'GENERAL.CANCEL' | translate }}
            </button>

            <button
                *ngIf="action === 'approve'"
                type="button"
                class="btn w-50"
                [ngClass]="request.customerType === 'AcademiaStudent' ? 'btn-tertiary' : 'btn-primary'"
                (click)="submit()"
                data-uit="extend-trial-approve-button"
            >
                {{ (request.customerType === 'AcademiaStudent' ? 'GENERAL.CONFIRM' : 'GENERAL.APPROVE') | translate }}
            </button>

            <button
                *ngIf="action === 'deny'"
                type="button"
                class="btn btn-danger w-50"
                [disabled]="!formGroup.valid"
                (click)="submit()"
                data-uit="extend-trial-deny-button"
            >
                {{ 'GENERAL.DENY' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
